"use strict";

var decodeHtml = require("html-encoder-decoder").decode,
    showdown = require("showdown"),
    hljs = require("highlight.js");

module.exports = function showdownHighlight() {
    return [{
        type: "output",
        filter: function filter(text, converter, options) {
            var left = "<pre><code\\b[^>]*>",
                right = "</code></pre>",
                flags = "g",
                replacement = function replacement(wholeMatch, match, left, right) {
                match = decodeHtml(match);
                return left + hljs.highlightAuto(match).value + right;
            };

            return showdown.helper.replaceRecursiveRegExp(text, replacement, left, right, flags);
        }
    }];
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/showdown-highlight/lib/index.js
// module id = udZ0
// module chunks = 0